import React from 'react';
import { Handshake, ExternalLink } from 'lucide-react';

/**
 * Full-width collaborator card shown below the quick-info grid for non-Dust products
 * (Dust Suppression products show the collaborator inline inside the quick-info grid instead).
 */
const ProductCollaborator = ({ product }) => {
  if (!product.collaborator || product.category === 'Dust Suppression System') return null;

  return (
    <div className="mb-8" data-testid="product-collaborator">
      <div className="group relative">
        <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-blue-500/10 rounded-xl blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        <div className="relative bg-white/90 backdrop-blur-xl border border-gray-200 rounded-xl p-5 sm:p-6 hover:border-cyan-300 transition-all hover:shadow-xl">
          <div className="flex items-center gap-4 flex-wrap sm:flex-nowrap justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-lg flex items-center justify-center flex-shrink-0 shadow-md">
                <Handshake className="h-5 w-5 text-white" />
              </div>
              <div className="text-sm font-semibold text-gray-700 whitespace-nowrap">Our Collaborator</div>
            </div>
            <a
              href={product.collaborator.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-cyan-600 to-blue-600 text-white rounded-lg px-5 py-2.5 font-semibold text-sm hover:shadow-lg hover:shadow-cyan-500/30 transform hover:scale-105 transition-all"
              data-testid="collaborator-link"
            >
              <span>{product.collaborator.name}</span>
              <ExternalLink className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCollaborator;
